<template>
    <div class="fillcontain">
        <div class="table_container">
            <el-row>
              <el-col :span="3">
                <el-select v-model="pages.main_store_id" placeholder="全部分店" style="width:100%;" @change="storesData()">
                  <el-option
                    key="0"
                    label="全部总门"
                    value="0">
                  </el-option>
                  <el-option
                    v-for="item in mainStores"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="3" style="margin-left: 10px">
                <el-select v-model="pages.store_id" placeholder="全部分店" style="width:100%;" @change="initData()">
                  <el-option
                    key="0"
                    label="全部门店"
                    value="0">
                  </el-option>
                  <el-option
                    v-for="item in stores"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="3" style="margin-left: 10px">
                <el-select v-model="showType" placeholder="数据类型" style="width:100%;"  @change="initData()">
                  <el-option
                    key="1"
                    label="菜品销售明细"
                    value="1">
                  </el-option>
                  <el-option
                    key="2"
                    label="菜品销售总额"
                    value="2">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="3" style="margin-left: 10px">
                <el-date-picker style="width:100%;"
                  v-model="pages.start_time"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="开始时间">
                </el-date-picker>
              </el-col>
              <el-col :span="3" style="margin-left: 10px">
                <el-date-picker style="width:100%;"
                  v-model="pages.end_time"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="结束时间">
                </el-date-picker>
              </el-col>
              <el-col :span="6"  style="margin-left: 10px">
                <el-button @click="initData">搜索</el-button>
                <el-button type="primary" @click="exportExcel">导出订单</el-button>
              </el-col>

            </el-row>
            <br/>

          <el-table
            :data="showData"
            style="width: 100%"
            v-loading="loading">
            <el-table-column
              label="总店"
              prop="store.mainStore.name">

            </el-table-column>
            <el-table-column
              label="门店"
              prop="store.name">

            </el-table-column>
            <el-table-column
              label="菜品类名称"
              prop="goods.goodsGroup.name">

            </el-table-column>
            <el-table-column
              label="菜品名称"
              prop="goodsName">
            </el-table-column>

            <el-table-column
              label="数量"
              prop="count">
            </el-table-column>
            <el-table-column
              label="单价"
              :formatter="unitPriceFormat">
            </el-table-column>
            <el-table-column
              label="总额(￥)"
              :formatter="realPriceFormat">
            </el-table-column>
            <el-table-column v-if="showType == '1'"
                             label="点菜人"
                             :formatter="createUserNameFormat">
            </el-table-column>
            <el-table-column
              label="点菜时间"
              prop="orders.updateTime" v-if="showType == '1'">
            </el-table-column>
          </el-table>
          <div class="Pagination">
            总金额：<span v-text="totalOrderData.totalPrice/100"></span>元
          </div>
        </div>

    </div>
</template>

<script>
    export default {
        components: {

        },
        data(){
            return {
              baseUrl:window.server.baseUrl,
                loading:false,
                pages:{
                    start_time:"",
                    end_time:"",
                    store_id:"0",
                    main_store_id:"0",
                },
                showType:"1",
                showData:[],
                orderGoodsData: [],
                totalOrderData : {totalPrice:0},
                orderGoodsStatData: [],
                stores:[],
                mainStores:[],
            }
        },
        created(){
            this.mainStoresData();
            this.storesData();
            this.initData();
        },
        methods: {
            initData(){
              if(this.pages.start_time == "" || this.pages.end_time == ""){

                return;
              }
              this.loading = true;
              var that = this;
              that.$api.get('/super_admin/stat/order_goods', that.pages, response => {
                if (response.status >= 200 && response.status < 300) {
                  var res = response.data;
                  if (res.code == 0) {
                    that.orderGoodsData = res.data.orderGoods;
                    that.orderGoodsStatData = res.data.statOrderGoods;
                    that.totalOrderData = res.data.totalOrderGoods;
                    that.showTypeData();
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                }
                this.loading = false;
              });
            },
          mainStoresData(){
            this.loading = true;
            var that = this;
            that.$api.get('/super_admin/main_store', {page:1,pageSize: 10000,get_store:true}, response => {
              if (response.status >= 200 && response.status < 300) {
                var res = response.data;
                if (res.code == 0) {
                  that.mainStores = res.data.main_store.content;
                  that.storesData();
                }else{
                  this.$message({
                    message: res.msg,
                    type: 'warning'
                  });
                }
              } else {
                this.$message({
                  message: "服务器维护中",
                  type: 'error'
                });
              }
              this.loading = false;
            });
          },
          storesData(){
            this.stores = [];
            this.pages.store_id = "0";
            this.loading = true;
            var that = this;
            that.$api.get('/super_admin/store', {page:1,pageSize: 10000,main_store_id:this.pages.main_store_id }, response => {
              if (response.status >= 200 && response.status < 300) {
                var res = response.data;
                if (res.code == 0) {
                  that.stores = res.data.stores.content;
                }else{
                  this.$message({
                    message: res.msg,
                    type: 'warning'
                  });
                }
              } else {
                this.$message({
                  message: "服务器维护中",
                  type: 'error'
                });
              }
              this.loading = false;
            });
          },
          exportExcel(){
            if(this.pages.start_time == "" || this.pages.end_time == ""){
              this.$message({
                message: "导出数据请先选择时间区间",
                type: 'warning'
              });
              return;
            }
            var storage=window.localStorage;
            var accessToken = storage["access_token"];
            location.href=this.baseUrl+"/super_admin/stat/excel?access_token="+accessToken+"&showType="+this.showType+"&start_time="+this.pages.start_time+"&end_time="+this.pages.end_time+"&main_store_id="+this.pages.main_store_id+"&store_id="+this.pages.store_id;
          },
          showTypeData(){
            if(this.showType == "1"){
              this.showData = this.orderGoodsData;
            }else{
              this.showData = this.orderGoodsStatData;
            }
          },
          realPriceFormat(row,column){
            return (row.totalPrice/100).toFixed(2);
          },
          createUserNameFormat(row,column){
              if(row.orders.consumer != null){
                return row.orders.consumer.nickName
              }else{
                return "员工："+row.orders.createdUser.account;
              }
          },
          unitPriceFormat(row,column){
            return ((row.totalPrice/row.count)/100).toFixed(2);
          },
        },
    }
</script>

<style lang="less">
	@import '../../style/mixin';
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
    .table_container{
        padding: 20px;
        text-align: left;
    }
    .Pagination{
        display: flex;
        justify-content: flex-start;
        margin-top: 8px;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
    }
    .avatar {
        width: 120px;
        height: 120px;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/pages/superAdmin/OrderGoodsStat.vue